import axios from "axios";
require("dotenv").config();
import store from "../store";

export default () => {
	const axiosConnection = axios.create({
		// baseURL: `http://googli.cz`
		// baseURL: `http://localhost:` + 8081
		baseURL:
			process.env.NODE_ENV === "development"
				? `http://localhost:` + 8081
				: "https://googli.cz/"
	});
	const intercept = axiosConnection.interceptors.request.use(config => {
		config.headers.userName = store.getters["getUser"];
		const token = localStorage.getItem("token");
		if (token) {
			config.headers.Authorization = `Bearer ${token}`;
		}
		return config;
	});
	return axiosConnection;
};



// WEBPACK FOOTER //
// ./src/services/Api.js